import get from 'lodash-es/get';
import { CAR_TYPES } from 'client/data/constants/car-types';

/**
 * This function returns car-type name by slug from params.
 * @param {String} typeSlug
 * @return {String}
 */
export function getCarTypeNameBySlug(typeSlug) {
  const carType = CAR_TYPES.find(type => type.slug === typeSlug);
  return get(carType, 'name', '');
}
